export const DEFAULT_PAGE = '1';
export const DEFAULT_STATUS = 'all';
export const DEFAULT_SPECIALIZATION_NUMBER = 11;
export const MAX_LIMIT_CATEGORIES = 5;
export const MAX_LIMIT_SPECIALIZATIONS = 5;
export const MAX_CHOOSE_QUESTION_COUNT = 8;
export const COLLECTION_QUESTIONS_LIMIT = 20;
